import { regMobile } from "@/util/util";

export default {
    data() {
        return {
            mobile: '',
            password: '',
            reg_password: '',
            input_type1: true,
            input_type2: true,
            invite: '',
            code: '',
            disabled: true,
            codeText: '获取验证码',
            is_select: true
        }
    },

    methods: {
        // 关闭
        close() {
            this.$emit('close');
        },

        // 去登录
        open() {
            // this.$emit('open');
            this.$parent.$parent.openLoginPop();
        },

        openUser() {
            this.$parent.$parent.closeMask();
            this.$router.push({
                name: 'user'
            })
        },

        openPrivacy() {
            this.$parent.$parent.closeMask();
            this.$router.push({
                name: 'privacy'
            })
        },

        // 获取验证码
        getCode() {
            if(!regMobile(this.mobile)) {
                this.$message.error('请输入正确的手机号！')
                return;
            }
            if(this.disabled) {
                this.$post('api.php/Index/sendCode',{
                    type: 1,
                    mobile: this.mobile
                }).then(res => {

                    if(res.status == 1) {
                        this.$message.success(res.info);
                        this.disabled = false;
                        let second = this.$second;
                        this.codeText = second + 's';
                        this.timer = setInterval(() => {
                            second--;
                            if (second >= 0) {
                                this.codeText = second + 's'
                            }else {
                                clearInterval(this.timer);
                                this.codeText = '重新获取';
                                this.disabled = true;
                            }
                        },1000);
                    }else {
                        this.$message.info(res.info);
                    }
                })


            }
        },

        // 注册
        reg() {
            if(!regMobile(this.mobile)) {
                this.$message.error('请输入正确的手机号！')
                return;
            }
            if(!this.code) {
                this.$message.error('请输入验证码！')
                return;
            }
            if(!this.password.trim()) {
                this.$message.error('请设置登录密码！')
                return;
            }
            if(!this.reg_password.trim()) {
                this.$message.error('请再次输入密码！')
                return;
            }
            if(this.password !== this.reg_password) {
                this.$message.error('两次密码输入不一致，请重新输入！')
                return;
            }
            if(!this.is_select) {
                this.$message.error('请先阅读并同意《用户协议》《隐私协议》！');
                return;
            }

            this.$post('api.php/Index/register',{
                mobile: this.mobile,
                code: this.code,
                password: this.password,
                rePassword: this.reg_password,
                invite_code: this.invite
            }).then(res => {

                if(res.status == 1) {
                    this.$message.success(res.info);
                    localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(res.data || {})));
                    this.$store.commit('setUser',res.data || {})
                    this.$parent.$parent.userinfo = this.$getUserinfo()
                    // this.$parent.$parent.openLoginPop();
                    this.mobile = '';
                    this.code = '';
                    this.password = '';
                    this.reg_password = '';
                    this.invite = '';
                    // this.$parent.$parent.closeMask();
                    this.$parent.$parent.checkLogin();
                    this.$parent.$parent.closeMask();
                }else {
                    this.$message.error(res.info);
                }
            })
        }
    }
}
